/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Wizard_Job_HintInputs */



/**
* | output |
* | --- |
* | "Say what it should look at, what it should produce, and for whom. You can be as informal as you like." |
*
* @param {Agent_Wizard_Job_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_wizard_job_hint = /** @type {((inputs?: Agent_Wizard_Job_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Wizard_Job_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sagen Sie, was er sich ansehen soll, was dabei herauskommen soll und für wen. Das darf ganz locker formuliert sein.")
	return /** @type {LocalizedString} */ ("Say what it should look at, what it should produce, and for whom. You can be as informal as you like.")
});